export const userRoles = {
  administration: 'administration',
  carrier: 'carrier',
  shipper: 'shipper',
  deliverer: 'deliverer',
};
